import queryString from 'query-string'
import getRequest from '../getRequest'
import { firebaseAuth } from '../../config/firebaseconfig'
import getTrueProps from '../getTrueProps';
import {connect} from 'react-redux'

 function authUser(email, password, success, district) {
  return new Promise((resolve, reject) => {
    const data = {
      email,
      password,
    }
    if (district) data.district = district
    const query = queryString.stringify(data)
    const url = `https://us-central1-bellwork-cg1.cloudfunctions.net/authEducator3?${query}`
    // const url = `http://localhost:5001/bellwork-cg1/us-central1/authEducator3?${query}`
    let userData = null
    getRequest(url)
      .then((res) => {
        return JSON.parse(res)
      })
      .then(({customToken, user, error}) => {
        localStorage.setItem('token',customToken)
        userData = user
        if (error) {
          throw error
        }
        return firebaseAuth().signInWithCustomToken(customToken)
      })
      .then((authResponse) => {
        resolve(success(userData)) 
      })
      .catch((err) => {
        reject(err)
      })
  })
}

// export function mgetUser(customToken, success) {
//   return new Promise((resolve, reject) => {
//     const data = {
//      customToken
//     }
//     const query = queryString.stringify(data)
//     const url = `https://us-central1-bellwork-cg1.cloudfunctions.net/authEducator1?${query}`
//     let userData = null
//     getRequest(url)
//       .then((res) => {
//         return JSON.parse(res)
//       })
//       .then(({user, error}) => {
//         console.log("customToken",customToken)
//         userData = user
//         if (error) {
//           throw error
//         }
//         return firebaseAuth().signInWithCustomToken(customToken)
//       })
//       .then((authResponse) => {
//         resolve(success(userData)) 
//       })
//       .catch((err) => {
//         reject(err)
//       })
//   })
// }



export default authUser


// WEBPACK FOOTER //
// ./src/helpers/users/authUser.js